import styled from 'styled-components';

import { Footer as oFooter } from 'components/Cards/DataCardFlights/styles';

export const AirlineLogo = styled.div`
  width: 24px;
  height: 24px;
`;

export const Footer = styled(oFooter)`
  height: 66px;
`;
